import {Type} from '@angular/core';

export class Tab {
    public id: number;
    public title: string;
    public tabData: any;
    public active: boolean;
    public component: Type<any>;
    public router: string;
    public isNewtab: boolean;
    public currentId: number;
    public tabHeading:any;

    constructor(title: string, tabData: any, router: any,isNewtab:boolean,currentId?: number,tabHeading?:any) {
        this.tabData = tabData;
        // this.component = component;
        this.title = title;
        this.router = router;
        this.isNewtab = isNewtab;
        this.currentId = currentId;
        this.tabHeading = tabHeading;
    }
    
}



// WEBPACK FOOTER //
// D:/ESealStore_AJS/src/app/components/Multitab/tab.model.ts